import { UtilService } from "@app/_services/util.service";
import { ApexOptions } from "apexcharts";

export type ReportsBarChartOptionsConfig = {
	/** When true, total dataLabels format duration via UtilService.parseMS. */
	formatDurationTotals?: boolean;
};

/** Shared Apex bar chart base for reports + schedules graphs. */
export function createReportsBarChartOptions(config: ReportsBarChartOptionsConfig = {}): ApexOptions {
	const total: {
		enabled: boolean;
		offsetY: number;
		style: Record<string, string | number>;
		formatter?: (val?: string) => string;
	} = {
		enabled: true,
		offsetY: -10,
		style: {
			fontSize: "0.875rem",
			fontWeight: 700,
			color: "hsl(var(--secondary))",
			fontFamily: "inherit",
		},
	};
	if (config.formatDurationTotals) {
		total.formatter = (val?: string) => {
			const v = parseFloat(val);
			if (!v) return "";
			const formatted = UtilService.parseMS(v * 1000, {
				showNegative: false,
				showSeconds: false,
			});
			return formatted?.toString() ?? "";
		};
	}
	return {
		chart: {
			height: "100%",
			type: "bar",
			selection: {
				enabled: false,
			},
			zoom: {
				enabled: false,
			},
			background: "transparent",
			toolbar: { show: false },
		},
		tooltip: {
			followCursor: false,
			shared: true,
			intersect: false,
			onDatasetHover: {
				highlightDataSeries: false,
			},
		},
		xaxis: {
			labels: {
				style: {
					cssClass: "text-muted-foreground drop-shadow",
				},
			},
			axisBorder: {
				color: "#242424",
			},
		},
		plotOptions: {
			bar: {
				horizontal: false,
				hideZeroBarsWhenGrouped: true,
				dataLabels: {
					total,
				},
			},
		},
	};
}
